/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequirementTemplate } from './RequirementTemplate';
import {
  RequirementTemplateFromJSON,
  RequirementTemplateFromJSONTyped,
  RequirementTemplateToJSON,
} from './RequirementTemplate';

/**
 *
 * @export
 * @interface PaginatedRequirementTemplateList
 */
export interface PaginatedRequirementTemplateList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRequirementTemplateList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRequirementTemplateList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRequirementTemplateList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RequirementTemplate>}
   * @memberof PaginatedRequirementTemplateList
   */
  results: Array<RequirementTemplate>;
}

/**
 * Check if a given object implements the PaginatedRequirementTemplateList interface.
 */
export function instanceOfPaginatedRequirementTemplateList(value: object): value is PaginatedRequirementTemplateList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRequirementTemplateListFromJSON(json: any): PaginatedRequirementTemplateList {
  return PaginatedRequirementTemplateListFromJSONTyped(json, false);
}

export function PaginatedRequirementTemplateListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRequirementTemplateList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RequirementTemplateFromJSON),
  };
}

export function PaginatedRequirementTemplateListToJSON(value?: PaginatedRequirementTemplateList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RequirementTemplateToJSON),
  };
}
